/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { BabelLoading } from 'react-loadingg';
import ImageUploader from 'react-images-upload';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import {
  createLoggedIssue,
  storeUploadedImage,
} from '../../lib/utilities/index';

const HelpForm = (props) => {
  const issueTypes = useSelector((store) => store.issueTypes.issueTypes);

  const [selectedIssue, setSelectedissue] = useState('Please select an option');
  const [selectedIssueResolutions, setSelectedissueResolutions] = useState([]);
  const [resolutions, setResolutions] = useState(false);
  const [showCommentsField, setShowCommentsField] = useState(false);
  const [validationPassed, setValidationPassed] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);
  const [validationFailedMessage, setValidationFailedMessage] = useState(false);
  const [commentMessage, setCommentMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [showMaxUploadMessage, setShowMaxUploadMessage] = useState(false);
  const [showCaptureDetails, setShowCaptureDetails] = useState(false);
  const [modalValid, setModalValid] = useState(true);
  const [userEmail, setuserEmail] = useState();
  const [userMobile, setuserMobile] = useState();
  const pictureElement = useRef(null);

  const path = window.location.search;

  const handleClose = () => setShowCaptureDetails(false);

  useEffect(() => {
    if (
      path.includes('?') &&
      path.includes('username') &&
      path.includes('mobileNumber')
    ) {
      const email = path.split('?username=').pop().split('&')[0];
      const mobile = path.substring(path.lastIndexOf('=') + 1);
      setuserEmail(email);
      setuserMobile(mobile);
    }
  }, []);

  const selectIssueType = (value) => {
    setSelectedissue(value);
    getIssueResolutions(value);
  };

  const getIssueResolutions = (chosenIssue) => {
    if (Array.isArray(issueTypes)) {
      issueTypes.forEach((issueItem) => {
        if (issueItem.issue === chosenIssue && chosenIssue !== 'Other') {
          setSelectedissueResolutions(issueItem.resolutions);
          setResolutions(true);
          setValidationFailedMessage(false);
          setShowCommentsField(true);
        }
        if (chosenIssue === 'Other') {
          setShowCommentsField(true);
          setResolutions(false);
        }
      });
      setShowSubmit(true);
    }
  };

  const setCommentMessageHandler = (value) => {
    setValidationPassed(true);
    setCommentMessage(value.target.value);
  };

  const setDetailsHandler = (type, value) => {
    if (type && type === 'email') {
      setuserEmail(value.target.value);
    }
    if (type && type === 'mobile') {
      setuserMobile(value.target.value);
    }
  };

  const onChangeHandler = async (files) => {
    let allUploadedFiles = files;
    setUploadedFiles(allUploadedFiles);
  };

  const onSubmitHandler = async () => {
    if (userEmail && userMobile && validationPassed) {
      setModalValid(true);
      setShowCaptureDetails(false);
      setLoading(true);
      let images;

      if (Array.isArray(uploadedFiles) && uploadedFiles.length > 0) {
        images = await storeUploadedImage(uploadedFiles);
      } else {
        images = [];
      }

      let issue = {
        status: 'Pending',
        statusColor: 'orange',
        email: userEmail,
        mobile: userMobile,
        comment: commentMessage ? commentMessage : '',
        uploads: images ? images : '',
      };

      if (validationPassed) {
        let ticketId = await createLoggedIssue(issue);
        issue.ticketId = ticketId;

        setCommentMessage('');
        /**
         * setShowSubmit(false) setShowSubmit(true) below is to refresh the ImageUploader to clear the cached images that were uploaded.
         * it basically forces the ImageUploader to rerender
         */
        setShowSubmit(false);
        setShowSubmit(true);
        setValidationFailedMessage(false);
        setUploadedFiles([]);
        Swal.fire({
          text: 'Your issue has been successfully submitted',
          icon: 'success',
          width: '80%',
          confirmButtonText: 'Okay',
        });
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      } else {
        setValidationFailedMessage(true);
      }
    } else if (!validationPassed) {
      setValidationFailedMessage(true);
    } else {
      setShowCaptureDetails(true);
      setModalValid(false);
    }
  };

  return (
    <Container>
      <Row>
        <Col xs={12}>
          <InputHeading>What do you need help with?</InputHeading>
        </Col>

        <Col xs={12}>
          <DropdownButton
            variant="outline-secondary"
            title={selectedIssue}
            id="input-group-dropdown-1"
            style={{ width: '100%', display: 'flex' }}
            onSelect={selectIssueType.bind()}
          >
            {Array.isArray(issueTypes)
              ? issueTypes.map((info, index) => (
                  <Dropdown.Item
                    style={{ marginBottom: 10, whiteSpace: 'break-spaces' }}
                    eventKey={info?.issue}
                    key={`${info?.issue}-${index}`}
                  >
                    {info.issue.trim()}
                  </Dropdown.Item>
                ))
              : null}
          </DropdownButton>
        </Col>
        {resolutions ? (
          <Col xs={12}>
            <InputHeading style={{ marginTop: '1rem' }}>
              We think this might resolve your issue
            </InputHeading>
          </Col>
        ) : null}

        {resolutions && Array.isArray(selectedIssueResolutions)
          ? selectedIssueResolutions.map((info, index) => (
              <Row
                key={`${info?.issue}-${index}`}
                style={{ margin: '0', marginBottom: '10px' }}
              >
                {info.name !== 'What is the Privacy Policy?  ' &&
                info.name !== 'What is the Terms & Conditions policy? ' ? (
                  <Col xs={12} key={index}>
                    <ResolutionCard>
                      <InputHeading style={{ textAlign: 'left' }}>
                        {info.name}
                      </InputHeading>
                      {info.description}
                    </ResolutionCard>
                  </Col>
                ) : (
                  <Col xs={12} key={index}>
                    <ResolutionCard>
                      <InputHeading style={{ textAlign: 'left' }}>
                        {info.name}
                      </InputHeading>
                      {info.name === 'What is the Privacy Policy?  ' ? (
                        <span>
                          Please click <Link to="/Privacy">here</Link> to view
                          our privacy policy
                        </span>
                      ) : (
                        <span>
                          Please click <Link to="/Terms">Terms</Link> to view
                          our terms & conditions policy.
                        </span>
                      )}
                    </ResolutionCard>
                  </Col>
                )}
              </Row>
            ))
          : null}

        {showMaxUploadMessage ? (
          <Col xs={12}>
            <span
              style={{
                width: '100%',
                float: 'left',
                marginTop: '5%',
                color: 'red',
                fontSize: '0.8rem',
                fontWeight: 'bold',
              }}
            >
              Please note that you can only upload 3 images per issue.
            </span>
          </Col>
        ) : null}

        {showSubmit ? (
          <>
            <Col xs={12}>
              <InputHeading style={{ marginTop: '1rem', textAlign: 'left' }}>
                Attach a file screenshot, or document
              </InputHeading>
            </Col>
            <ImageUploader
              {...props}
              withIcon={true}
              onChange={onChangeHandler}
              imgExtension={['.jpg', '.jpeg', '.gif', '.png']}
              maxFileSize={5242880}
              withPreview
              className="uploadImageBtn"
              ref={pictureElement}
            />
          </>
        ) : null}

        {showCommentsField ? (
          <Col xs={12}>
            <InputHeading style={{ marginTop: '1rem' }}>Comments</InputHeading>
            <CommentsInput
              onChange={setCommentMessageHandler}
              placeholder="please leave your comments here"
              value={commentMessage}
            />
          </Col>
        ) : null}

        {validationFailedMessage ? (
          <Col xs={12}>
            <span
              style={{
                width: '100%',
                float: 'left',
                marginTop: '5%',
                color: 'red',
                fontSize: '0.8rem',
                fontWeight: 'bold',
              }}
            >
              Please fill out the comments field to submit your issue
            </span>
          </Col>
        ) : null}

        {loading ? (
          <Col xs={12}>
            <BabelLoading
              color="#316797"
              style={{
                float: 'right',
                marginTop: '1rem',
                position: 'relative',
              }}
            />
          </Col>
        ) : null}

        {showSubmit && !loading ? (
          <Col xs={12}>
            <SubmitIssueButton onClick={onSubmitHandler}>
              Submit
            </SubmitIssueButton>
          </Col>
        ) : null}

        <Modal
          show={showCaptureDetails}
          onHide={handleClose}
          dialogClassName="escalateModal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Please confirm your details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {modalValid ? (
              <span
                style={{
                  width: '100%',
                  float: 'left',
                  marginTop: '5%',
                  color: 'red',
                  fontSize: '0.8rem',
                  fontWeight: 'bold',
                }}
              >
                Please provide a valid mobile number and email address.
              </span>
            ) : null}
            <DetailsInput
              onChange={setDetailsHandler.bind(this, 'email')}
              placeholder="email"
              style={{ marginTop: '5%' }}
              type="email"
            />
            <DetailsInput
              onChange={setDetailsHandler.bind(this, 'mobile')}
              placeholder="mobile number"
              style={{ marginTop: '5%' }}
              type="number"
            />
          </Modal.Body>
          <Modal.Footer>
            <Col xs={4}>
              <SubmitIssueButtonModal
                style={{ background: 'orange' }}
                onClick={handleClose}
              >
                Cancel
              </SubmitIssueButtonModal>
            </Col>
            <Col xs={4}>
              <SubmitIssueButtonModal
                style={{ background: '#316797' }}
                onClick={onSubmitHandler}
              >
                Confirm
              </SubmitIssueButtonModal>
            </Col>
          </Modal.Footer>
        </Modal>
      </Row>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 3%;
  margin: 5% auto;
  position: relative;
  display: flex;
  justify-content: center;
`;

const InputHeading = styled.div`
  text-align: center;
  font-size: 1rem;
  color: #d01e2d;
  margin-bottom: 1rem;
  width: 100%;
`;

const ResolutionCard = styled.div`
  text-align: left;
  padding: 0.6rem;
  width: 100%;
  font-size: 0.7rem;
  color: #666;
  border-radius: 5px;
  background: #fff;
  border: 1px solid #eee;
  box-shadow: 0px 4px 15px -4px #b6b6b6;
`;

const CommentsInput = styled.input`
  text-align: left;
  padding: 0.6rem;
  width: 100%;
  height: 100px;
  font-size: 0.7rem;
  color: #666;
  border-radius: 5px;
  background: #fff;
  border: 1px solid #eee;
  box-shadow: 0px 4px 15px -4px #b6b6b6;
`;

const DetailsInput = styled.input`
  text-align: left;
  padding: 0.6rem;
  width: 100%;
  font-size: 0.7rem;
  color: #666;
  border-radius: 5px;
  background: #fff;
  border: 1px solid #eee;
  box-shadow: 0px 4px 15px -4px #b6b6b6;
`;

const SubmitIssueButton = styled.div`
  background: #4c8b2b;
  color: #fff;
  font-size: 1rem;
  padding: 0.7rem;
  border-radius: 5px;
  float: right;
  margin-top: 1rem;
`;

const SubmitIssueButtonModal = styled.div`
  background: green;
  color: #fff;
  font-size: 0.7rem;
  padding: 0.5rem;
  border-radius: 5px;
  margin-top: 1rem;
  text-align: center;
`;

export default HelpForm;
